import ActionType from './types';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import {performRequest} from '../utils/';
import {searchURL} from '../utils/restUrls';
import store from '../store/configureStore';
import {selectSpot, zoomToSpot} from './parkingSpots';
import {GOTO_SEARCHED_SPOT_ZOOM_LEVEL} from '../constants';

export const openDrawer = () => {
  return (dispatch) => {
    dispatch({
      type: ActionType.SET_DRAWER_STATE,
      isDrawerOpened: true
    });
  };
};

export const closeDrawer = () => {
  return (dispatch) => {
    dispatch({
      type: ActionType.SET_DRAWER_STATE,
      isDrawerOpened: false
    });
  };
};

export const openNavHelp = () => {
  return (dispatch) => {
    dispatch({
      type: ActionType.SET_NAV_HELP_STATE,
      isNavHelpOpened: true
    });
  };
};

export const closeNavHelp = () => {
  return (dispatch) => {
    dispatch({
      type: ActionType.SET_NAV_HELP_STATE,
      isNavHelpOpened: false
    });
  };
};

export const openSearchForm = () => {
  return (dispatch) => {
    dispatch({
      type: ActionType.SET_NAV_SEARCH_STATE,
      isSearchFormOpened: true
    });
  };
};

export const closeFilterSpotsForm = () => {
  return (dispatch) => {
    dispatch({
      type: ActionType.SET_NAV_SEARCH_STATE,
      isSearchFormOpened: false
    });
  };
};

export const openFindPeopleForm = () => {
  return (dispatch) => {
    dispatch({
      type: ActionType.SET_NAV_SEARCH_PEOPLE_STATE,
      isFindPeopleFormOpened: true
    });
  };
};

export const closeFindPeopleForm = () => {
  return (dispatch) => {
    dispatch({
      type: ActionType.SET_NAV_SEARCH_PEOPLE_STATE,
      isFindPeopleFormOpened: false
    });

    dispatch({type: ActionType.RESET_SEARCH});
  };
};

export const goToParkingHome = () => {
  browserHistory.push('/parking');
};

export const afterCheckoutConfirmation = () => {
  return (dispatch) => {
    dispatch({type: ActionType.RESET_SEARCH});
    dispatch({type: ActionType.RESET_SELECTED_SPOT});
    dispatch({type: ActionType.RESET_NAV_OPTIONS});

    browserHistory.push('/parking');
  };
};

export const performSearch = () => {
  const {query} = store.getState().search;
  const url = searchURL(query);

  return (dispatch) => (
    performRequest(url, 'GET', {q: query})
      .then(body => {
        dispatch({type: ActionType.RESET_SEARCH_LOADING});

        return dispatch({
          type: ActionType.SET_SEARCH_RESULT,
          result: (typeof body.data === 'string') ? JSON.parse(body.data) : body.data
        });
      })
  );
};

export const setSearchString = (value) => {
  return (dispatch) => {
    dispatch({type: ActionType.SET_SEARCH_LOADING});
    dispatch({
      type: ActionType.SET_SEARCH_QUERY,
      query: value
    });
  };
};

export const handleSearchPeople = (searchStr) => {
  return (dispatch) => {
    dispatch(setSearchString(searchStr));
  };
};

export const onClickSearchResult = (spotId) => {
  return (dispatch) => {
    dispatch(selectSpot(spotId));

    dispatch({
      type: ActionType.SET_NAV_SEARCH_PEOPLE_STATE,
      isSearchFormOpened: false
    });

    dispatch( zoomToSpot(spotId, GOTO_SEARCHED_SPOT_ZOOM_LEVEL) );
  };
};

export const onClickDrawerUserReservedSpot = (spotId) => {
  return (dispatch) => {
    dispatch(selectSpot(spotId));

    dispatch({
      type: ActionType.SET_DRAWER_STATE,
      isDrawerOpened: false
    });

    dispatch( zoomToSpot(spotId) );
  };
};

export const toggleDetails = (spotInfoDetailedView) => {
  return (dispatch) => {
    dispatch({
      type: ActionType.SET_NAV_SPOT_INFO_DETAILED_VIEW,
      spotInfoDetailedView: !spotInfoDetailedView
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/navOptions.js